interface Props {
  size?: number;
  withWordmark?: boolean;
}

export function SnapmonLogo({ size = 32, withWordmark = true }: Props) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <img
        src="/snapmon-icon.png"
        width={size}
        height={size}
        alt="Snapmon"
        style={{
          display: 'block',
          borderRadius: Math.round(size * 0.22),
          border: '1px solid var(--line)',
          flexShrink: 0,
        }}
      />
      {withWordmark && (
        <span
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: 17,
            letterSpacing: '-0.02em',
            color: 'var(--ink)',
          }}
        >
          Snapmon
          <span style={{ color: 'var(--brand)' }}>.</span>
        </span>
      )}
    </div>
  );
}
